<template lang="pug">
OrderActionModal(v-if="show" :show="show" max-width="min(100vw - 2rem, 34rem)" @close="onClose")
  template(slot="header")
    span.delivery-data-modal__title.uppercase Guías · {{ recordLabel }}

  .delivery-data-modal
    .delivery-data-modal__actions(v-if="canCreateNewDeliveryForRecord(recordData)")
      shActionButton(
        :action="createNewDelivery"
        text="Nueva entrega"
        textRunning="Creando entrega"
        :normalColor="true"
      )

    DeliveryDataList(
      :record="recordData"
      :on-cancel-tracking="cancelTrackingGuide"
      :on-decline-delivery="declineDelivery"
    )
</template>

<script>
import gql from '@my/graphql'
import gqlOrder from '@/graphql/order'
import gqlChange from '@/graphql/change'
import gqlDelivery from '@/graphql/delivery'
import modals from '@my/store/modals'
import OrderActionModal from '@/components/pages/order/refund/OrderActionModal.vue'
import DeliveryDataList from '@/components/elements/delivery/DeliveryDataList.vue'
import shActionButton from '@/components/elements/ActionButton.vue'
import { canCreateNewDeliveryForRecord } from '@/helpers/deliveryMass'

export default {
  name: 'DeliveryDataModal',

  components: {
    OrderActionModal,
    DeliveryDataList,
    shActionButton
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: null
    }
  },

  computed: {
    recordData () {
      return this.record
    },

    recordLabel () {
      if (!this.recordData) return ''
      if (this.recordData.change) return `c${this.recordData.change}`
      return this.recordData.order || ''
    }
  },

  methods: {
    canCreateNewDeliveryForRecord,

    onClose () {
      this.$emit('close')
    },

    findDeliveryDoc (deliveryId) {
      const deliveries = (this.recordData && this.recordData.deliveries) || []
      return deliveries.find(item => item.delivery === deliveryId)
    },

    async cancelTrackingGuide (entry) {
      if (!entry || !entry.delivery) return true

      const errors = []
      const response = await gql.mutate(gqlDelivery.CANCEL_TRACKING, { delivery: entry.delivery }, false, errors)

      if (errors.length) {
        modals.showMessage({ message: errors[0], type: 'error' })
        return true
      }

      if (response) {
        const deliveryDoc = this.findDeliveryDoc(entry.delivery)
        if (deliveryDoc) this.$set(deliveryDoc, 'trackingCancelled', true)
        modals.showMessage({ message: `Guía anulada para la entrega ${entry.delivery}` })
        this.$emit('updated')
      }

      return true
    },

    async declineDelivery (entry) {
      if (!entry || !entry.delivery) return true

      const errors = []
      const response = await gql.mutate(gqlDelivery.DECLINE, { delivery: entry.delivery }, false, errors)

      if (errors.length) {
        modals.showMessage({ message: errors[0], type: 'error' })
        return true
      }

      if (response) {
        const deliveryDoc = this.findDeliveryDoc(entry.delivery)
        if (deliveryDoc) this.$set(deliveryDoc, 'status', 'declined')
        modals.showMessage({ message: `Entrega ${entry.delivery} declinada` })
        this.$emit('updated')
      }

      return true
    },

    async createNewDelivery () {
      if (!this.recordData) return true

      const type = this.recordData.change ? 'exchange' : 'order'
      const errors = []
      let response

      if (this.recordData.change) {
        response = await gql.mutate(gqlChange.NEW_DELIVERY, { change: this.recordData.change, type }, false, errors)
      } else {
        response = await gql.mutate(gqlOrder.NEW_DELIVERY, { order: this.recordData.order, type }, false, errors)
      }

      if (errors.length) {
        modals.showMessage({ message: errors[0], type: 'error' })
        return true
      }

      if (response) {
        modals.showMessage({ message: 'Nueva entrega creada' })
        this.$emit('refresh')
      }

      return true
    }
  }
}
</script>

<style lang="stylus" scoped>
.delivery-data-modal
  padding 0 1.5rem 1.5rem
  overflow-y auto
  max-height calc(100vh - 8rem)

.delivery-data-modal__title
  font-size 1rem
  font-weight 600

.delivery-data-modal__actions
  margin-bottom 1.5rem
  padding-bottom 1.5rem
  border-bottom 1px solid var(--color-border)
</style>



// WEBPACK FOOTER //
// src/components/elements/delivery/DeliveryDataModal.vue